import { CollegeDebitsResponse } from "infrastructure/services/types/college.entity";
import { RootState } from "./rootReducer";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  debits: [],
  accounts: [],
  hasCardBlack: false
} as CollegeDebitsResponse;

export const collegeDebitsReducer = createSlice({
  name: "CollegeDebitsReducer",
  initialState,
  reducers: {
    saveCollegeDebits: (state, action: PayloadAction<CollegeDebitsResponse>) => {
      return action.payload;
    },
    resetCollegeDebits: () => {
      return initialState;
    },
  },
});

export const { resetCollegeDebits, saveCollegeDebits } = collegeDebitsReducer.actions;

export const getCollegeDebitsRedux = (state: RootState) => { return state };

export const getCollegeDebits = (state: RootState) => { return state.collegeDebitsReducer.debits };

export const getCollegeDebitsAccounts = (state: RootState) => { return state.collegeDebitsReducer.accounts };

export const getCollegeDebitsHasCardBlack = (state: RootState) => state.collegeDebitsReducer.hasCardBlack;

export default collegeDebitsReducer.reducer;
